import { StackProps, Stack } from "@mui/material";
import { NoticeBanner } from "components/molecules/NoticeBanner";
import { MemberPortalConfigContext } from "contexts/MemberPortalConfigContext";
import React, { FC, memo, useContext } from "react";

export const NoticeBanners: FC = memo((props: StackProps) => {
  const { memberPortalConfig } = useContext(MemberPortalConfigContext);
  return !!memberPortalConfig?.noticeBanners.length && (
    <Stack gap={1} mb={2} {...props} >
      {memberPortalConfig?.noticeBanners
        ?.filter((banner) => banner.isActive)
        .map((banner, index) => (
          <NoticeBanner key={index} notice={banner} />
        ))}
    </Stack>);
});